import styles from './VarItem.module.css';

const VarItem = ({
  item,
  i,
  answerFontSize,
  varNumFontSize,
  isQuestionImg,
}) => {
  return (
    <div
      className={styles.varInfo}
      style={{ minHeight: isQuestionImg ? 'none' : '20rem' }}>
      <div
        className={styles.varNumber}
        style={{
          fontSize: `${varNumFontSize}rem`,
          height: `${1.17 * varNumFontSize}rem`,
          minWidth: `${1.17 * varNumFontSize}rem`,
        }}>
        {i + 1}
      </div>
      <div
        className={styles.varTitle}
        style={{
          fontSize: `${answerFontSize}rem`,
          maxWidth: isQuestionImg ? '78rem' : '47.92rem',
        }}>
        {item.comment}
      </div>
    </div>
  );
};

export default VarItem;
